import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';
import Address from '@/Model/Address';

export default class CurrentAddressChangedMessage extends Message {
    public context;

    public changedAddress: Address;

    public contextIdentifier: string;

    public constructor(params: any) {
        super(params);

        this.changedAddress = params.changedAddress;
        this.contextIdentifier = params.contextIdentifier;
    }
}

ComponentManager.setMessage('CurrentAddressChangedMessage', CurrentAddressChangedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');